import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";

const RenderBox = ({ style, superStyle, classes, children, attributes, extraClasses }) => {
    const contClass = containerClasses();
    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");

    return (
        <div style={{ width: "100%", ...superStyle }}>
            <div style={style} className={classes + " " + extraClasses} {...attributes}>
                {children}
            </div>
        </div>
    );
}

export const Box = ({ style, classes = [], children, superStyle, attributes, extraClasses }) => (
    <Fragment>
        <RenderBox {...{ style, superStyle, classes, children, attributes, extraClasses }} />
    </Fragment>
);